module.exports = __webpack_public_path__ + "static/media/landingcoverVector.b71df8c3.png";